import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation, useQuery } from '@tanstack/react-query'
import { PreviousApplicationInputDto } from '../../types/PreviousApplicationInputDto'
import { PreviousApplication } from '../../types/PreviousApplicationSchema'

// Query Keys
export const previousApplicationKeys = {
  all: ['previousApplication'] as const,
  byApplicant: (filter: PreviousApplicationInputDto | null) => [...previousApplicationKeys.all, filter] as const,
}

const BASE_URL = '/PreviousApplication'

const getPreviousApplicationsByFilters = async (filter: PreviousApplicationInputDto): Promise<PreviousApplication[]> => {
  const apiClient = getApiClient()
  const response = await apiClient.post<PreviousApplication[]>(BASE_URL, filter)
  return response.data
}

export function useGetPreviousApplications(): [
  MutationFunction<PreviousApplication[], PreviousApplicationInputDto>,
  boolean,
  boolean,
  () => void,
] {
  const { mutateAsync, isPending, isError, reset } = useMutation({
    mutationFn: getPreviousApplicationsByFilters,
  })

  return [mutateAsync, isPending, isError, reset]
}

export function useGetPreviousApplicationsQuery(
  filter: PreviousApplicationInputDto | null,
): [PreviousApplication[], boolean] {
  const { data, isFetching } = useQuery({
    queryKey: previousApplicationKeys.byApplicant(filter),
    queryFn: () => (filter ? getPreviousApplicationsByFilters(filter) : Promise.resolve([])),
    enabled: filter !== null,
  })

  return [data ?? [], isFetching]
}
